export * from "./crown.svg";
export * from "./helmet.svg";
export * from "./specs.svg";
export * from "./hat.svg";

export const z = 4;
